import { FunctionComponent } from 'react';

export const NoVideoInputMessage: FunctionComponent = () => {
  return (
    <div className="w-full aspect-w-16 aspect-h-9 bg-black">
      <div className="w-full h-full v-stack items-center space-y-3 justify-center">
        <img className="w-8 h-8" src="/images/icons/nintendo_switch_white.svg" />
        <div className="px-4">
          <h2 className="text-white text-2xl text-center">No video input</h2>
          <h3 className="text-gray-400 text-center">
            Select your capture card video input from the menu on your left.
          </h3>
        </div>
      </div>
    </div>
  );
};
